import { Actions, AppMiddleware, AppDispatch } from '..';
import { Lightbox } from 'sofa-reborn-react';
import {
	buildTipHasBeenShown,
	hidePopOver,
	setBannerHasBeenShown,
	setPlacementInformationHasBeenShown,
} from '../popOver';
import { setShowOpenDesign } from '../openDesign';
import { setCurrentLightbox, setAppView, setHasVisitScene } from '../application/actions';
import { showScreensaver, showTimeoutWarning } from '../screensaver/actions';
import { setStoreId } from '../../store/localization/actions';
import {
	fetchVpcSuccess,
	screenshotSuccess,
	setVisibleModal,
	setSavedVpcConfiguration,
} from '../checkout/actions';
import { setSelectedConfiguration, setPersistedConfiguration } from '../sofaConfiguration/actions';
import { selectSceneItem } from '../scene/actions';
import {
	setShowFunctionSleep,
	setShowFunctionStorage,
	setShowMeasurements,
	setShowSelectAll,
} from '../actionButtons/actions';
import { SET_LOADING_MODELS } from '../application/types';
import { SHOW_SCREENSAVER, RESET_SCREENSAVER_TIMEOUT } from '../screensaver/types';
import { UrlService } from '../../services';

let screensaverTimer = -1;
let timeoutWarningTimer = -1;

function resetTimer(
	currentLightbox: Lightbox,
	showIpexGalleryButton: boolean,
	idleTime: number | null,
	dispatch: AppDispatch
): void {
	clearTimeout(screensaverTimer);
	clearTimeout(timeoutWarningTimer);

	const countdownBannerTimeout = showIpexGalleryButton
		? idleTime
			? idleTime * 1000
			: 60000
		: currentLightbox === 'product-intro-gallery'
		? 15000
		: 90000;
	const screensaverTimeout = countdownBannerTimeout + 90000;

	if (!showIpexGalleryButton) {
		screensaverTimer = window.setTimeout((): void => {
			resetScene(dispatch);
			resetApplication(dispatch);
		}, screensaverTimeout);
	}
	timeoutWarningTimer = window.setTimeout((): void => {
		dispatch(showTimeoutWarning({ show: true, sendEvent: false }));
	}, countdownBannerTimeout);
}

const resetScene = (dispatch: AppDispatch): void => {
	dispatch(showScreensaver(true));

	dispatch(hidePopOver({ type: 'all' }));
	dispatch(setShowOpenDesign(false));
	dispatch(selectSceneItem(null));
	dispatch(setShowMeasurements(true, false));
	dispatch(setShowFunctionSleep(false, false));
	dispatch(setShowFunctionStorage(false, false));
	dispatch(setShowSelectAll(false));
	dispatch(buildTipHasBeenShown(false));
	dispatch(showTimeoutWarning({ show: false, sendEvent: false }));
	dispatch(setSelectedConfiguration({ configuration: {} }));
	dispatch(setCurrentLightbox('product-intro-gallery'));
	dispatch(setAppView('build-view'));
	dispatch(setPlacementInformationHasBeenShown(false));
	const newHash = UrlService.getReplacedIdHash('');
	UrlService.setBrowserWindowHash(newHash);

	/* Reset PIG scroll */
	const productViewWrapperElement = document.getElementById('product-view');
	if (productViewWrapperElement) {
		productViewWrapperElement.scrollTop = 0;
	}
};

const resetApplication = (dispatch: AppDispatch): void => {
	dispatch(setStoreId(UrlService.getStoreId()));
	dispatch(setSavedVpcConfiguration(null));
	dispatch(setBannerHasBeenShown(false));
	dispatch(setVisibleModal(null));
	dispatch(setHasVisitScene(false));
	/* Reset persist variables */
	dispatch(setPersistedConfiguration(null));
	dispatch(screenshotSuccess(null));
	dispatch(fetchVpcSuccess(null));
};

function clearTimer(): void {
	clearTimeout(screensaverTimer);
	clearTimeout(timeoutWarningTimer);
}

const screensaverMiddleware: AppMiddleware =
	(api) =>
	(next) =>
	(action: Actions): Actions => {
		const result = next(action);
		const state = api.getState();
		const { currentLightbox, showIpexGalleryButton, idleTime, isInUpptackaPlatform } =
			state.application;
		const { showScreensaver } = state.screensaver;
		const { platform } = state.deviceInfo;

		switch (action.type) {
			case SET_LOADING_MODELS:
			case RESET_SCREENSAVER_TIMEOUT:
				if (platform === 'kiosk' && !isInUpptackaPlatform && !showScreensaver) {
					// only set timer IFF kiosk
					resetTimer(currentLightbox, showIpexGalleryButton, idleTime, api.dispatch);
				} else if (isInUpptackaPlatform) {
					window.parent.postMessage(
						{
							method: 'upptacka_userinteraction',
						},
						'*'
					);
				}
				break;
			case SHOW_SCREENSAVER:
				if (platform === 'kiosk' && !action.value) {
					// only set timer IFF kiosk
					resetTimer(currentLightbox, showIpexGalleryButton, idleTime, api.dispatch);
				} else {
					clearTimer();
				}
				break;
		}

		return result;
	};

export { resetScene, resetApplication, screensaverMiddleware };
